export default __webpack_public_path__ + "static/ready-cta-5873b144f5b1e1a5e36ab4d9c5300b23.webp";